/* eslint-disable */
var baseApiUrl = ''
if (process.env.NODE_ENV === 'production') {
  // This will be replaced with the server endpoint for demo purposes
  baseApiUrl = 'https://api.cprp.com.au/public/'
  // baseApiUrl = 'http://sustainabilitybackend.geodemosolutions.com/public/'
  // baseApiUrl = 'http://sustainabilitybackend.geodemosolutions.com/'
 }
else {
  baseApiUrl = 'http://localhost/centralhubapi/public/'
  // baseApiUrl = 'http://localhost:8000/'

}

export {
  baseApiUrl
}
